import store from '../store';
import handlerData from './handler_data';
import axios from 'axios';
export default {
  send_start_message (subChannel, payload = '') {
    // console.log(store.state.styles.customerButtonText);

    let customButtonText = '';
    try {
      customButtonText = store.state.styles.customerButtonText;
    } catch (error) {
      
    }

    let data_msg = {
      "channel": 'livechat',
      "sub_channel": subChannel,
      "sender_id": store.state.clientId,
      "sender_name": store.state.clientName,
      "bot_code": store.state.botCode,
      "message": {
          "type": 'payload',
          "content": 'get_started#' + payload + '#' + (customButtonText ? customButtonText : 'Bắt đầu')
      }
    }

    store.state.scClient.emit('user_send_message', data_msg)
  },
  send_message_to_socket (type, content, subChannel) {
    // console.log(store)
    // send to socket
    let data_msg = {
        "channel": 'livechat',
        "sub_channel": subChannel,
        "sender_id": store.state.clientId,
        "sender_name": store.state.clientName,
        "bot_code": store.state.botCode,
        "message": {
            "type": type,
            "content": content
        }
    }

    store.state.scClient.emit('user_send_message', data_msg)
  },

  async upload_file_to_server (botCode, senderId, senderToken, file_id, file, subChannel) {
    // let clientInfo = handlerData.getClientInfo(botCode);
    let channel = 'livechat';

    let status = false;

    let formData = new FormData();
    formData.append('attachment', file);
    if (subChannel) {
      formData.append('sub_channel', subChannel);
    }

    let url = process.env.VUE_APP_API_URL_MSG_SERVER + "bot/" + botCode + "/user-upload-file-from-sc/c/"+ channel +"/s/" + senderId + "/f/" + file_id + "/";
    let header = { "headers": {
      "Authorization": "Bearer " + senderToken
    }}
    await axios.post(url, formData, header).then(response => {
      // console.log(response.data)
      // result_url = response.data.url
      status = true;
      
    }).catch(e => {
      console.log(e.response)
    })

    return status;
  },

  // receive_message_from_socket (message) {

  // }

  
  async send_react(botCode, senderId, senderToken, messageId, react) {
    let url = process.env.VUE_APP_API_URL_MSG_SERVER + "bot/" + botCode + "/user-react-message/" + senderId + "/"
    let data_post = {
      sender_id: senderId,
      message_id: messageId,
      react: react
    }

    let header = { "headers": {
      "Authorization": "Bearer " + senderToken
    }}
    await axios.post(url, data_post, header).then(response => {
    }).catch(e => {
    })
  },

}